__turbopack_context__.v({
  "accent-text": "accent-text-module-scss-module__yE6dVW__accent-text",
  "placeholder": "accent-text-module-scss-module__yE6dVW__placeholder",
  "size-l": "accent-text-module-scss-module__yE6dVW__size-l",
  "size-m": "accent-text-module-scss-module__yE6dVW__size-m",
});
